import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Notification(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.681 20.943a1 1 0 110 2H9.962a1 1 0 110-2h3.72zM11.825 1.008c.365-.003.772.02 1.152.062a7.735 7.735 0 012.041.507c2.207.872 3.768 2.865 4.282 5.466.177.898.16 1.789.142 2.652-.006.246-.01.49-.01.732v2.878c0 1 .205 1.316.608 1.576 1.038.67 1.902 1.987 1.495 3.412-.178.734-.704 1.558-1.613 1.558h-16.2c-.91 0-1.435-.824-1.623-1.596-.398-1.387.466-2.703 1.504-3.374.403-.26.608-.576.608-1.576v-2.878c0-.242-.004-.486-.01-.732-.016-.863-.035-1.754.142-2.652.513-2.601 2.075-4.594 4.283-5.466a7.723 7.723 0 012.043-.507c.377-.041.753-.09 1.155-.062zm0 2l-.632.026a5.855 5.855 0 00-1.832.402c-2.14.846-2.833 2.866-3.056 3.996-.135.684-.12 1.43-.103 2.222.005.26.01.518.01.773v2.878c0 1.058-.172 2.383-1.522 3.256-.418.269-.779.763-.659 1.184.01.035.022.072.034.106h15.514a.83.83 0 00.023-.068c.13-.46-.23-.953-.649-1.222-1.348-.873-1.521-2.198-1.521-3.256v-2.878c0-.255.005-.513.01-.773.017-.791.032-1.538-.104-2.222-.223-1.13-.916-3.15-3.056-3.996a5.864 5.864 0 00-1.518-.378 7.102 7.102 0 00-.94-.05z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoNotification = React.memo(Notification);
export default MemoNotification;